import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import type * as React from "react";
import styled from "styled-components";
import { tabToRoute, useCurrentTab } from "@/hooks/useCurrentTab";
import { type ILanguage, LANGUAGE_NAMES, LANGUAGES } from "@/types";
import { normalizeLangsParam } from "@/urlState";

const Wrapper = styled.div`
    display: flex;
    gap: 0.5rem;
    label {
        margin-top: 0.5rem;
    }
`;

function LangSelector() {
    const { version } = useParams({ from: "/$version" });
    const navigate = useNavigate({ from: "/$version" });
    const langs = useSearch({ from: "/$version", select: (state) => state.langs });
    const tab = useCurrentTab();

    const enabled = new Set(langs ?? LANGUAGES);

    const toggle = (event: React.FormEvent<HTMLInputElement>) => {
        const lang = event.currentTarget.name as ILanguage;
        const checked = event.currentTarget.checked;

        const next = new Set(enabled);
        if (checked) {
            next.add(lang);
        } else {
            next.delete(lang);
        }

        const nextLangs = normalizeLangsParam(Array.from(next) as ILanguage[]);
        const to = tabToRoute(tab);

        navigate({
            to,
            params: { version },
            search: (prev) => ({ ...prev, langs: nextLangs, page: undefined }),
        });
    };

    return (
        <fieldset>
            <legend>Select languages to show</legend>
            <Wrapper>
                {LANGUAGES.map((lang) => (
                    <label key={lang}>
                        <input name={lang} type="checkbox" checked={enabled.has(lang)} onChange={toggle} />{" "}
                        {LANGUAGE_NAMES[lang]}
                    </label>
                ))}
            </Wrapper>
        </fieldset>
    );
}

export default LangSelector;
